import { MonoBehavior } from 'game/core/monoBehavior';
import { Store } from 'game/store/gameStore';
import { updateUIState, uiStore } from 'ui';

export default class TimeCounter extends MonoBehavior {

    private value: string = '00:00';

    update(): void {
        const newValue = Store.getTimeFormat(Store.time);

        if (this.value != newValue) {
            this.value = newValue;
            // Используем новую React UI систему
            uiStore.dispatch(updateUIState({
                gameStats: {
                    ...uiStore.getState().gameUI.gameStats,
                    time: newValue
                }
            }));
        }
    }
}
